import { render, staticRenderFns } from "./MonitorsParagraphsObjects.vue?vue&type=template&id=573fcb78&"
import script from "./MonitorsParagraphsObjects.vue?vue&type=script&lang=js&"
export * from "./MonitorsParagraphsObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports